import { ModelHelper } from '../classes/model-helper';
import { WorkflowToken } from '../enums/workflow-token.enum';

/**
 * Workflow model
 */
export class Workflow {
	token: WorkflowToken;

	/**
	 * Static mapping function
	 *
	 * @param data
	 * @param workflow
	 * @returns Workflow
	 */
	static map(data: any, workflow: Workflow = new Workflow()): Workflow {
		return workflow.map(data);
	}

	/**
	 * Non static mapping function
	 *
	 * @param data
	 * @return Workflow
	 */
	public map(data: any): Workflow {
		ModelHelper.map(data, this, 'token');

		return this;
	}
}
